<template>
  <div>
    <h3 class="mb-5">
      {{ $t('On Hold') + ' (' + ad.name + ')' }}
    </h3>

    <p class="mb-10">{{ $t('Kindly provide the advertiser with the reasons to ensure he understands where the problem lies and help him make the necessary adjustments.') }}</p>

    <div>
      <ul class="mt-6">
        <li class="my-3" v-for="reason in reasons" :key="'reason-' + reason.id">
          <vs-checkbox v-model="form.review_reason_ids" :vs-value="reason.id">
            <p class="ml-3">
              {{ reason.reason }}
            </p>
          </vs-checkbox>
        </li>
      </ul>

      <h3 class="reasons-err ml-2" v-if="errors.has('review_reason_ids')">{{errors.first('review_reason_ids')}}</h3>

      <vs-textarea class="mt-6" :label="$t('Other Comments')" v-model="form.summary" />
    </div>

    <div class="text-right">
      <vs-button class="mr-4" color="rgb(200, 200, 200)" textColor="#000" type="filled" @click="cancel()">
        {{ $t('Close') }}
      </vs-button>

      <vs-button color="primary" type="filled" @click="submitReview()">
        {{ $t('Submit') }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import {getReviewReasons} from '@/utils/ReviewReasons'

export default {
  props: {
    ad: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        ad_id: this.ad.id,
        summary: '',
        review_reason_ids: [],
        acceptance_status: 2 // 2 for hold
      }
    }
  },
  computed: {
    reasons () {
      return getReviewReasons(
        this.$constants.AD_REVIEW_REASON_TYPE_IDS.HOLD,
        false
      )
    }
  },
  watch: {
    reasons () {
      if (this.reasons) {
        this.form.review_reason_ids = this.reasons.map(i => i.id)
      }
    }
  },
  methods: {
    cancel () {
      this.errors.clear()

      this.$emit('cancel-hold')
    },
    async submitReview () {

      this.errors.clear()

      try {
        const response = await window.axios.post(`/campaigns/${this.$route.params.id}/review-ad`, this.form)

        // reset form state
        this.form.summary = ''
        this.form.review_reason_ids = this.reasons.map(i => i.id)

        // fire success events
        this.$emit('acceptance-status-updated', response.data.payload)
        this.$emit('cancel-hold')
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    }
  }
}
</script>

<style lang="scss">
  .reasons-err {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #db2828;
  }
</style>
